// Short-link redirect policy: which stored redirects this app may follow.

import { ENV_IS_DEVELOPMENT } from '../data/environment'

// Hosts whose redirects are THIS app: strip to an in-app path. The dev
// servers only exist in development builds (the local API mints :5173 links)
const CREW_HOSTS = new Set([
  'crew.cretesuite.com',
  'preview.cretesuite.com',
  ...(ENV_IS_DEVELOPMENT
    ? ['localhost:5173', 'localhost:5200', 'localhost:5201', 'localhost:5202']
    : []),
])

// '//host' and '/\\host' both parse as host-relative (WHATWG treats '\\' as
// '/' for http), so neither is an in-app path
const HOST_RELATIVE = /^\/[/\\]/

/** In-app path for a stored redirect, or null when it points off-app. */
export const internalPathForRedirect = (redirect: string): string | null => {
  if (HOST_RELATIVE.test(redirect)) return null
  if (redirect.startsWith('/')) return redirect
  try {
    const url = new URL(redirect)
    const isCrewHost =
      CREW_HOSTS.has(url.host) || url.host === window.location.host
    if (!isCrewHost) return null
    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return null
  }
}

/** history decodes location.pathname; a stored redirect may still be encoded */
export const decodePathname = (pathname: string): string => {
  try {
    return decodeURI(pathname)
  } catch (error) {
    console.error('[ShortLink] malformed redirect path', pathname, error)
    return pathname
  }
}

/** Fail closed: an unparseable expiry counts as expired. */
export const isExpired = (expires: string | null | undefined): boolean => {
  if (expires == null) return false
  const expiresAt = new Date(expires).getTime()
  return Number.isNaN(expiresAt) || expiresAt < Date.now()
}
